import { clientProtocolContext } from './clientContext'
import { supabase } from './supabaseClient'
import type { AthleteCompanionPayload } from './dailyOverrideTypes'

export type WellnessPillars = {
  stress: number
  fatigue: number
  sleep_quality: number
  muscle_soreness: number
  mood: number
}

export type MorningWellnessResponse = {
  readiness_signal: 'pull' | 'push'
  wellness_aggregate: number
  wellness_z_score: number | null
  athlete_companion: AthleteCompanionPayload | null
  briefing_text: string | null
}

export async function submitMorningWellness(
  pillars: WellnessPillars,
): Promise<{ result: MorningWellnessResponse | null; error: string | null }> {
  const ctx = clientProtocolContext()
  const { data, error } = await supabase.functions.invoke('calculate-readiness', {
    body: {
      ...ctx,
      ...pillars,
    },
  })

  if (error) return { result: null, error: error.message }
  if (data?.error) return { result: null, error: String(data.error) }

  return {
    result: {
      readiness_signal: data.readiness_signal,
      wellness_aggregate: data.wellness_aggregate,
      wellness_z_score: data.wellness_z_score ?? null,
      athlete_companion: (data.athlete_companion as AthleteCompanionPayload) ?? null,
      briefing_text: data.daily_override?.briefing_text ?? null,
    },
    error: null,
  }
}
